export function generateResourceKey(resource, action) {
  return `${resource.type}:${resource.id || ''}${action ? `:${action.name}` : ''}`;
}